import { Alert, Snackbar } from '@mui/material';
import type { AlertProps } from '@mui/material/Alert';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import { useJotaiErrorUpdate } from '../hooks/useJotaiErrorUpdate';
import { currentAuthAtom, popupAlertAtom } from '../jotai/atoms';

export function NoticeManager() {
  const [showing, setShowing] = React.useState<AlertProps>();

  // ステートが更新されたら Snackbar を表示する
  const alert = useAtomValue(popupAlertAtom);
  React.useEffect(() => {
    if (alert) {
      setShowing(alert);
    }
  }, [alert]);

  // それぞれのステートが更新されたら Snackbar を表示する
  useJotaiErrorUpdate(currentAuthAtom, error => {
    setShowing({
      severity: 'error',
      children: 'ログインできませんでした。詳しくはコンソールを見てください'
    });
    console.error(error);
  });

  const handleClose = React.useCallback((event: any, reason?: string) => {
    if (reason === 'clickaway') return; // 画面クリックでは閉じない
    setShowing(undefined);
  }, []);

  return (
    <Snackbar
      open={Boolean(showing)}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} {...showing} />
    </Snackbar>
  );
}
